import { render } from "./OffersPage.vue?vue&type=template&id=326c9108&scoped=true"
const script = {}

import "./OffersPage.vue?vue&type=style&index=0&id=326c9108&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-326c9108"]])

export default __exports__